import Components from './DateRange.vue';

const dateRange = {
    install:function(Vue) {
        Vue.component('dateRange', Components)
    }
}

export default dateRange;